import { useTranslation } from 'react-i18next';
import { OidcProtectedComponent } from '@nohara/react-oidc';
import { useParams } from 'react-router';
import { permission } from '@nohara/oidc-core';

import { ContentLayout } from '@/components/layouts';
import { paths } from '@/config/paths';

const permissions = [permission.org.update];

const OrgSettingsRoute = () => {
  const { t } = useTranslation();
  const { orgId } = useParams<{ orgId: string }>();

  return (
    <OidcProtectedComponent
      requireAll={permissions}
      redirectTo={paths.org.root.path}
      context={{ orgId }}
    >
      <ContentLayout title={t('settings.title')}>
        <div>{t('settings.description')}</div>
      </ContentLayout>
    </OidcProtectedComponent>
  );
};

export default OrgSettingsRoute;
